<template>
  <div id="content">
    <form autocomplete="off">
      <div class="inner">
        <p class="paging">
          <a class="btn btn_back"
             @click="navigateToPreviousRoute()"
             v-translate>Seznam
          </a>
        </p>
        <h1 v-translate>Přidat uživatele</h1>
      </div>
      <div class="responsiveTabs">
        <div class="tabs_content">
          <section>
            <div class="left">
              <h2 v-translate>Základní údaje</h2>
              <p class="profile_image_box">
                <label for="user_image"
                       :class="['profile_image', {is_image: userImage}]"
                       :title="'Nahrát fotku' | translate">
                  {{ userInitials }}
                  <img :src="userImage" v-if="userImage">
                </label>
                <input
                    type="file"
                    name="user_image"
                    id="user_image"
                    class="input_file"
                    data-multiple-caption="{count} files selected"
                    @change="onFileChange"
                    ref="user_image">
                <label for="user_image" class="add_profile_image">
                  <span v-translate>Nahrát fotku</span> (150×150px)
                </label>
              </p>
            </div>
            <div class="right">
              <div class="field_left">
                <text-input id="name"
                            :required="true"
                            v-model="entity.name"
                            ref="nameref"
                >
                  <translate class="translate">Příjmení a jméno</translate>
                </text-input>
                <text-input
                    :required="true"
                    id="real-login"
                    v-model="entity.login"
                    ref="realloginref"
                >
                  <translate class="translate">Login</translate>
                </text-input>
                <select-box id="operator"
                            v-model="entity.id_operator"
                            :options="operatorOptions"
                            :disabled="!canEditOperator"
                >
                  <translate class="translate">Operátor</translate>
                </select-box>
              </div>
              <div class="field_right">
                <input id="login" name="login" type="text" style="display: none">
                <input id="password" name="password" type="password" style="display: none">
                <text-input
                    :required="true"
                    input-type="password"
                    id="real-password"
                    v-model="password"
                    ref="realpasswordref"
                >
                  <translate class="translate">Heslo</translate>
                </text-input>
                <text-input
                    :required="true"
                    id="email"
                    v-model="entity.email"
                    ref="useremail"
                >
                  <translate class="translate">Email</translate>
                </text-input>
                <text-input
                    id="phone"
                    v-model="entity.phone"
                    ref="userphone"
                >
                  <translate class="translate">Telefon</translate>
                </text-input>
              </div>
            </div>
          </section>
          <section>
            <div class="left">
              <h2 v-translate>Nastavení oprávnění</h2>
            </div>
            <div class="right">
              <select-box
                  id="idrolegroup"
                  v-model="entity.id_role_group"
                  :options="roleGroups"
                  :disabled="!isOperatorRole && !$_loggedUser_action_allowed('roleGroups', 'update')"
              >
                <translate class="translate">Skupina oprávnění</translate>
              </select-box>
              <role-groups-select-list
                  v-if="$_loggedUser_action_allowed('roleGroups', 'update')"
                  v-model="entity.roles_override"
                  :is-editable="!!entity.id_role_group"
                  :is-user="true"
                  :user-role="entity.role"
                  :edit-allowed-sections="edit_allowed_section_list"
                  ref="roleGroupsBasicFormRef"
              />
            </div>
          </section>
          <section class="buttons">
            <p>
              <a class="btn btn_back btn_seznam"
                 @click="navigateToPreviousRoute()"
                 v-translate>Seznam
              </a>
              <input
                  type="submit"
                  :value="'Uložit' | translate"
                  :class="['btn']"
                  @click.prevent.stop="createUser()"
              />
            </p>
          </section>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import RoleGroupsSelectList from "@/components/views/roleGroups/forms/RoleGroupsSelectList";

import message from "@/components/mixins/message"
import userSettings from "@/components/mixins/user-settings"
import users from "@/components/views/users/mixins/users"
import requiredFields from "@/components/mixins/required-fields"
import {Tabs} from "@/components/views/operators/OperatorDetail"

export default {
  name: "UserNew",
  components: {RoleGroupsSelectList},
  mixins: [message, userSettings, requiredFields, users],
  data() {
    return {
      userUpdateFields: ['id', 'name', 'login', 'email', 'phone', 'id_operator', 'role', 'id_role_group', 'roles_override'],
      entity: {
        id_operator: Number(this.$store.getters.operatorId),
        role: 'ROLE_OPERATOR'
      }
    }
  },
  created(UserService, OperatorService, RoleGroupsService) {
    this.userService = UserService
    this.operatorService = OperatorService
    this.roleGroupsService = RoleGroupsService;
    this.operatorId = this.$route.params.operatorId
    this.getRoleGroupsSimpleList();
    this.getEditAllowedSectionList();
    this.getOperatorsAndSetIdOperatorToEntity()
        .then(() => {
          if (this.operatorId) {
            this.entity.id_operator = this.operatorId
          }
        })
  },
  computed: {
    userImage() {
      if (this.selectedFile) {
        return URL.createObjectURL(this.selectedFile)
      }
    },
    canEditOperator() {
      return this.$_createActionAllowedAllOrOwnAndGlobal;
    }
  },
  methods: {
    createUser(redirect = false) {
      this.userService.createEntity(this.filterUserParams({...this.entity}))
          .then(data => {
            this.saveLastVisited(data.id)
            this.uploadImage(data.id)

            if (redirect === true) {
              this.navigateToPreviousRoute()
            } else {
              this.$router.push({name: 'userDetail', params: {id: data.id}})
            }
          })
          .catch(function (error) {
            this.setErrorMessage(this.processErrorMessage(error))
          }.bind(this))
    },
    navigateToPreviousRoute() {
      if (this.operatorId) {
        this.$router.push({name: 'operatorDetail', params: {id: this.operatorId, activeTab: Tabs.users}})
      } else {
        this.$router.push({name: 'users'})
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/users/UserNew.vue